import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _CompetitionType, _Entailment, _GenericCompetition } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    IDCompetitionType: number;
    idSelector: number;
    onChange: any;
    label?: string;
}

export const GenericCompetitionEditor = ({ IDCompetitionType, idSelector, onChange, label }: Props) => {

    const GenericCompetition = useDataBean(_GenericCompetition)
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector);
        getLista();
    }, [IDCompetitionType])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }


    const getLista = () => {

        GenericCompetition.instance.getGenericCompetitionCatalog(IDCompetitionType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Competencias Genéricas:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDGenericCompetition} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}